const Radio = {
    baseStyle: {
        control: {
            _checked: {
                _before: {
                    alignItems: 'center',
                    background: 'primary.500',
                    borderRadius: '50%',
                    content: `""`,
                    display: 'inline-block',
                    h: '12px',
                    position: 'relative',
                    w: '12px',
                },
                _hover: {
                    background: 'white',
                    borderColor: 'black',
                },
                background: 'white',
                borderColor: 'neutral.600',
            },
            _hover: {
                borderColor: 'black',
            },
            alignItems: 'center',
            background: 'white',
            borderColor: 'neutral.600',
            borderRadius: '50%',
            borderWidth: '1px',
            display: 'inline-flex',
            height: '20px',
            width: '20px',
        },
        label: {
            color: 'black',
            fontSize: 'md',
            fontWeight: 400,
            lineHeight: '24px',
            marginInlineStart: '8px',
        },
    },
};
export default Radio;
